import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20background%20with%20scattered%20newspaper%20textures%20and%20warm%20golden%20highlights%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20deep%20amber%20and%20black%20tones%2C%20elegant%20editorial%20style%2C%20investigative%20journalism%20aesthetic%2C%20soft%20light%20leaks&width=1600&height=800&seq=cta-bg-home&orientation=landscape"
        alt="独家深扒内幕直击"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>

      <div className="relative max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight">
              独家深扒
              <br />
              内幕直击
            </h2>
            <Link
              to="/category/dujia-bagua"
              className="mt-8 inline-flex items-center gap-3 px-8 py-3.5 bg-white text-foreground-900 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap"
            >
              查看独家内容
              <span className="w-6 h-6 bg-foreground-950 rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </Link>
          </div>
          <div className="max-w-md">
            <p className="text-white/80 text-base leading-relaxed">
              深入追踪每一条爆料的来龙去脉，还原事件真相。吃瓜网独家深扒频道，带你看清表面之下的暗流涌动
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}